export default "__VITE_ASSET__BkDxoYmB__"